import { Route } from '@angular/router';
import { CommandeParamSettingsComponent } from './commande-param-settings.component';
import { ClientResolver } from './shared/client-resolver';


export const CommandeParamSettingsRouting: Route = {
  path: ':id',
  component: CommandeParamSettingsComponent,
  resolve: {
    client: ClientResolver,
  },
  data: {
    breadcrumb: ":client.full_name"
  }
}
